export const I18N_NAMESPACE = 'onboarding';

// Captive portal notification
export const CAPTIVE_PORTAL_NOTIFICATION_CLICK =
    'Click ActivationNotification ActivateAccount_lnk';
